import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "components/card";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { PencilAltIcon, TrashIcon } from "@heroicons/react/outline";
import Swal from "sweetalert2";
import axios from "../../../../api/axios";
import { TailSpin } from "react-loader-spinner";
import jwtDecode from "jwt-decode";

const CheckTable = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // 🔑 Read & decode token
  const storedToken = localStorage.getItem("token");
  let userRole = null;

  if (storedToken) {
    try {
      const decoded = jwtDecode(storedToken);
      userRole =
        decoded[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ] || null;
    } catch (err) {
    }
  }

  const token = "Bearer " + storedToken?.replace(/"/g, "");
  const headers = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  // // ✏️ Edit & Delete
  // const handleEdit = (id) => {
  //   navigate(`/admin/userdetails`, { state: { id } });
  // };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `/api/account/deleteAdministrator?userId=${id}`,
        { headers }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Administratori u fshi me sukses!",
          showConfirmButton: true,
          confirmButtonColor: "#18817d",
          confirmButtonText: "Mbyll",
          timer: 2500,
        });
        setTimeout(() => {
          window.location.href = "/admin/administrator";
        }, 2500);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Diçka shkoi keq! Ju lutem provoni përsëri",
        showConfirmButton: true,
        confirmButtonColor: "#18817d",
        confirmButtonText: "Mbyll",
        timer: 2500,
      });
    }
  };

  // 🌍 Locale text
  const customLocaleText = {
    noRowsLabel: "Nuk ka administratorë të regjistruar",
    footerRowSelected: (count) =>
      `${count === 1 ? "1 rresht" : `${count} rreshta`} i selektuar`,
  };

  // 📊 Columns
  const columns = [
    {
      field: "fullName",
      headerName: "Emri dhe mbiemri",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "phone",
      headerName: "Nr. telefonit",
      flex: 0.8,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "email",
      headerName: "Email adresa",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
    },
    {
        field: "role",
        headerName: "Pozita",
        flex: 0.7,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        valueGetter: (params) => {
          const role = params.row.role?.toLowerCase().replace("_", " ");

          switch (role) {
            case "admin":
              return "Admin";
              case "admin assistant":
              return "Asistent i Adminit";
            case "admin police":
              return "Admin";
            case "assistant police":
              return "Asistent i Adminit";
            default:
              return role || "Nuk është përcaktuar";
          }
        },
    },
    {
      field: "institution",
      headerName: "Institucioni",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "actions",
      headerName: "Veprimet",
      flex: 0.7,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div className="flex items-center space-x-2">
          {/* <button onClick={() => handleEdit(rows[params.id]["userId"])}>
            <PencilAltIcon className="h-5 w-5 text-gray-500 hover:text-gray-700" />
          </button> */}
          <button onClick={() => handleDelete(rows[params.id]["userId"])}>
            <TrashIcon className="h-5 w-5 text-red-500 hover:text-red-700" />
          </button>
        </div>
      ),
    },
  ];

  // 📡 Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        //console.log("🔑 Token:", storedToken);

        const response = await axios.get("/api/account/getadministrators", {
          headers,
        });

        // console.log("📥 Të dhënat nga API:", response.data);
        // console.log(
        //   "🔎 Roli i secilit nga API:",
        //   response.data.map((r) => r.role)
        // );

        let filteredData = response.data;

        // ✅ Nëse userRole është police/admin_police/admin police → filtro
        if (
          userRole &&
          ["police", "admin_police", "admin police"].includes(
            userRole.toLowerCase().replace("_", " ")
          )
        ) {
          filteredData = response.data.filter((row) => {
            const role = row.role?.toLowerCase().replace("_", " ");
            return role === "admin police" || role === "assistant police";
          });
        }

        const rowsWithId = filteredData.map((row, index) => ({
          ...row,
          id: index,
        }));

        console.log("✅ Rreshtat final që do shfaqen:", rowsWithId);

        setRows(rowsWithId);
        setLoading(false);
      } catch (error) {
        console.error("❌ Gabim gjatë marrjes së administratorëve:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [storedToken, userRole]);

  // 🖼️ Render
  return (
    <>
      {loading ? (
        <div className="mt-11 flex items-center justify-center pt-11">
          <TailSpin color="#18817d" height={70} width={70} />
        </div>
      ) : (
        <Card extra={"w-full sm:overflow-auto p-4"}>
          <header className="relative flex items-center justify-between">
            <div className="pb-2 text-xl font-bold text-navy-700 dark:text-white">
              Lista e administratorëve
            </div>
          </header>
          <Box>
            <DataGrid
              rows={rows}
              columns={columns}
              className="text-black dark:text-white"
              getRowId={(row) => row.id}
              autoHeight
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
              }}
              pageSizeOptions={[10]}
              disableSelectionOnClick
              disableColumnMenu
              localeText={customLocaleText}
            />
          </Box>
        </Card>
      )}
    </>
  );
};

export default CheckTable;
